const TeamRoles = ['Leader', 'Member'];

export default TeamRoles;